
// 图片地址处理
export const imgFormat = (url, fileDomain= '') => {
  return {
    'url': url,
    'showProgress': false,
    'percentage': 100,
    'status': 'finished'
  }
}

